module.exports = __webpack_public_path__ + "assets/icons/completed-jobs.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/sidemenu/completed-jobs.png
// module id = ./src/styles/icons/sidemenu/completed-jobs.png
// module chunks = 0